module.exports = __webpack_public_path__ + "static/media/doctor-patient-consultation-hospital-management.5cbea634.webp";